import axios from "axios";
import { FlowAdditionalCheckboxUpdateRequest } from "../models/requests/FlowAdditionalCheckboxUpdateRequest";
import { AutonomousFormAdditionalCheckbox } from "../models/responses/AutonomousFormAdditionalCheckbox";
import { FlowBaseCheckboxCreateRequestImpl } from "../models/requests/FlowBaseCheckboxCreateRequest";

const baseUrl = "/AutoConnectSSO/api/InscriptionFlow/InscriptionFlows";
function getUrl(flowId: number, checkboxId?: number) {
  const urlEnd = checkboxId?.toString() ?? "";
  return `/${flowId}/AdditionalCheckbox/${urlEnd}`;
}

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function getCheckbox(checkboxId: number, flowId: number) {
  const url = getUrl(flowId, checkboxId);
  return await instance.get<AutonomousFormAdditionalCheckbox>(url);
}

async function getCheckboxes(flowId: number) {
  const url = getUrl(flowId);
  return await instance.get<AutonomousFormAdditionalCheckbox[]>(url);
}

async function setCheckbox(
  checkboxId: number,
  flowId: number,
  checkbox: FlowAdditionalCheckboxUpdateRequest
) {
  return await instance.put<FlowAdditionalCheckboxUpdateRequest>(
    getUrl(flowId, checkboxId),
    checkbox
  );
}

async function deleteCheckbox(checkboxId: number, flowId: number) {
  return await instance.delete(getUrl(flowId, checkboxId));
}

async function createCheckbox(
  flowId: number,
  checkbox: FlowBaseCheckboxCreateRequestImpl
) {
  return await instance.post<AutonomousFormAdditionalCheckbox>(
    getUrl(flowId),
    checkbox
  );
}

export const AutonomousFormAdditionalCheckboxService = {
  getCheckbox,
  setCheckbox,
  deleteCheckbox,
  createCheckbox,
  getCheckboxes
};
